import styled, { css } from 'styled-components';

import { layout } from '../../../package.json';
import { config } from '../../config';

export const Root = styled.div`
  width: 100%;
  display: flex;

  justify-content: center;
  align-items: center;
  flex-direction: column;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  position: relative;
`;

export const Container = styled.div`
  max-width: 1400px;
  width: 100%;
  height: ${config.color.menu.height};
  margin: 0 auto;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 16px;

  @media (max-width: ${layout.mobile}) {
    justify-content: flex-start;
    padding: 0 8px;
  }
`;

export const ContainerBorder = styled.div`
  width: 100%;
  border-top: 1px solid #f0f0f0;
`;

export const Title = styled.div`
  width: 330px;
  background-color: var(--primary);
  color: var(--menucolor);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  padding: 5px;

  span {
    font-size: 22px;
  }
`;

export const ContainerCategoty = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: ${config.color.menu.height};
  overflow-x: auto;
  overflow-y: hidden;

  /* Hide scrollbar */
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

interface CategoryMenuProp {
  isDisable: boolean;
}

export const CategoryMenu = styled.div<CategoryMenuProp>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 40px;

  padding: 1px;

  background-color: #fff;
  color: #333;

  ${props => props.isDisable && `
    display: none;
  `}

  @media (max-width: ${layout.mobile}) {
    display: none;
  }
`;

interface CategoryMenuMobileProp {
  isEnable: boolean;
}

export const CategoryMenuMobile = styled.div<CategoryMenuMobileProp>`
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    select {
      width: 100%;
      max-width: 250px;
      height: 40px;
      border: none;
      text-align: center;
      color: #333;
      font-size: 16px;
      border-bottom: 2px solid var(--primary);
    }
  ${props => !props.isEnable && `
    @media (min-width: ${layout.mobile}) {
      display: none;
    }
  `}

     ${props => props.isEnable && `
      display: flex !important;
    `}
`;

export const CategoryTitle = styled.div`
  margin-right: 8px;
  span {
    font-size: 18px;
  }
`;

export const ContainerOverFlow = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const ContainerCategotyList = styled.div`
  animation-duration: 0.5s;
  animation-name: slidein;

  @keyframes slidein {
    0% {
      transform: translateY(-500px);
      opacity: 1;
    }
    10% {
      transform: translateY(-200px);
      opacity: 1;
    }
    50% {
      transform: translateY(0px);
      opacity: 1;
    }
    80% {
      transform: translateY(0px);
      opacity: 1;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  transform: translateX(-48%);

  width: 100%;
  height: 100%;
`;

interface CategoryItemProps {
  selected?: boolean;
}

export const CategoryItem = styled.div<CategoryItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  background-color: #fff;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;

  ${props =>
    props.selected &&
    css`
      border-bottom: 2px solid var(--primary);
      font-weight: 500;
      
      span {
        color: var(--primary) !important;
      }
      
      svg {
        color: var(--primary) !important;
      }
    `}
  cursor: pointer;
  
  span {
    color: #333;
    font-size: 13px;
    font-weight: 700;
    padding: 6px 10px;
    transition: color 0.2s ease;
  }

  :hover {
    background-color: #f9f9f9;
    border-bottom: 2px solid var(--primary);
    
    span {
      color: var(--primary);
    }
    
    svg {
      color: var(--primary);
    }
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 12px;
      padding: 6px 8px;
    }
  }
  
  & + div {
    margin-left: 0;
  }
`;

export const SubcategoryCarouselItem = styled.div<CategoryItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  background-color: #fff;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;

  ${props =>
    props.selected &&
    css`
      border-bottom: 2px solid var(--primary);
      font-weight: 500;
      
      span {
        color: var(--primary) !important;
      }
    `}
  cursor: pointer;
  
  span {
    color: #666;
    font-size: 12px;
    font-weight: 500;
    padding: 6px 10px;
    transition: color 0.2s ease;
  }

  :hover {
    background-color: #f9f9f9;
    border-bottom: 2px solid var(--primary);
    
    span {
      color: var(--primary);
    }
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 11px;
      padding: 6px 8px;
    }
  }
  
  & + div {
    margin-left: 0;
  }
`;

export const AllProductsItem = styled.div<CategoryItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5px;
  height: 100%;
  background-color: #fff;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
  cursor: pointer;
  
  ${props =>
    props.selected &&
    css`
      border-bottom: 2px solid var(--primary);
      font-weight: 500;
      
      span {
        color: var(--primary) !important;
      }
      
      svg {
        color: var(--primary) !important;
      }
    `}
  
  span {
    color: #333;
    font-size: 13px;
    font-weight: 700;
    margin-left: 6px;
    transition: color 0.2s ease;
  }
  
  :hover {
    background-color: #f9f9f9;
    border-bottom: 2px solid var(--primary);
    
    span {
      color: var(--primary);
    }
    
    svg {
      color: var(--primary);
  }
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 12px;
    }
  }
`;

export const MenuListIten = styled.div`
  width: 100%;
  height: 52px;

  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HamburgerButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 6px;
  transition: background-color 0.2s;

  span {
    font-family: Roboto;
    font-size: 13px;
    font-weight: 700;
    color: #333;
  }

  &:hover {
    background-color: #f5f5f5;
  }

  @media (max-width: 768px) {
    padding: 4px 8px;
    gap: 4px;

    span {
      font-size: 12px;
    }
  }
`;

export const Separator = styled.div`
  width: 1px;
  height: 24px;
  background-color: #ddd;
`;

interface SidebarProps {
  open: boolean;
  isLargeScreen?: boolean;
  leftPosition?: number;
}

export const Sidebar = styled.div<SidebarProps>`
  position: fixed;
  top: 165px;
  left: ${(props) => {
    if (!props.open) return '-100%';
    if (props.isLargeScreen && props.leftPosition !== undefined) {
      return `${props.leftPosition}px`;
    }
    return '0';
  }};
  width: ${(props) => {
    if (props.isLargeScreen) {
      return '450px';
    }
    return '100vw';
  }};
  max-height: calc(100vh - 165px);
  background: #fff;
  color: #333;
  transition: left 0.3s ease-in-out;
  z-index: 9999;
  display: ${(props) => (props.open ? 'flex' : 'none')};
  flex-direction: column;
  box-shadow: ${(props) =>
    props.open ? '2px 2px 8px rgba(0,0,0,0.2)' : 'none'};
  border: 1px solid #eee;
  border-radius: 0 0 4px 4px;
  overflow: hidden;
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
  pointer-events: ${(props) => (props.open ? 'auto' : 'none')};
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
  svg {
    color: black;
  }
`;

export const SidebarTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0;
`;

export const SidebarContent = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 8px 0;
  overflow-y: auto;
  flex-grow: 1;
`;

export const SidebarItem = styled(CategoryItem)`
  width: 100%;
  justify-content: space-between;
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    padding: 10px 12px;
    font-size: 14px;
    text-align: left;
    display: block;
    flex: 1;
  }

  svg {
    margin-right: 12px;
    color: #666;
    flex-shrink: 0;
  }

  :hover {
    background-color: #f9f9f9;
  }

  ${props => props.selected && css`
    border-bottom: 2px solid var(--primary);
  `}
`;

export const SidebarCategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  margin: 0;
  padding: 0;
`;

export const SidebarSubcategoryList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f9f9f9;
  padding-left: 24px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-top: 0;
  animation: slideDown 0.2s ease-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
    to {
      opacity: 1;
      max-height: 500px;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
`;

export const SidebarSubcategoryItem = styled.div<CategoryItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  margin: 0;

  span {
    padding: 8px 12px;
    font-size: 13px;
    width: 100%;
    text-align: left;
    color: #666;
    font-weight: 500;
    transition: color 0.2s ease;
    display: block;
  }

  :hover {
    background-color: #f0f0f0;
    
    span {
      color: var(--primary);
    }
  }

  ${props => props.selected && css`
    background-color: #fff3f3;
    
    span {
      color: var(--primary);
      font-weight: 600;
    }
  `}
`;